import { BaseService } from 'shared/services/BaseService';
import { IPurchaseRequest } from '../types';

class PurchaseRequestLineService extends BaseService<IPurchaseRequest> {
  constructor() {
    super('purchreqline');
  }
}

export const purchaseRequestLineService = new PurchaseRequestLineService();
